// 直播组件
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useRef, useEffect } from 'react'
import { Card, theme, Segmented, Divider, Button, message } from 'antd'
import { SyncOutlined, CameraOutlined, PlusOutlined, MinusOutlined, ExpandOutlined, FullscreenExitOutlined } from '@ant-design/icons'

import { getWebSocketAddress, getM30AirportNumber, getAirLiveAddress, goToPointByTakeoff, goToPointByFlyTo, returnHome, startVideoAPI, endVideoAPI, takePhotoAPI, changeLensAPI, modifyZoomValueAPI, panTiltControlAPI, getAirportHealthInfoAPI, airportHealthInfoReadAPI, stopFlytoAPI, cancelReturnFlightAPI, getLinePointApi, getKmlLinePointApi } from '@/server/commandFlight.js'

import { pushFlowLiveAPI, flowLiveUpdateAPI } from '@/server/airportCamera'
import { debounce } from "@/common/js/common.js" //引入公共方法

import is_t_Camera from "@/common/img/command_flight/t_Camera.svg" //开始摄像
import is_f_Camera from "@/common/img/command_flight/f_Camera.svg" //停止摄像
import './live_video.css'
import FlvVideo from '@/component/FlvVideo/index.js'
import airportWarning from '@/common/img/video/airportWarning.svg';

function LiveVideo (list) {
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数

  const dock_id = list.dock_id
  const token = localStorage.getItem('dock_token');
  const { token: { colorBgContainer, colorText }, } = theme.useToken(); //获取主题颜色


  const liveUrlRef = useRef('')//直播地址
  const liveInterval = useRef(null)//直播更新  计时器
  const [videoId, setVideoId] = useState('')//直播id

  const [loading, setLoading] = useState(false)//加载中···

  const [lensType, setLensType] = useState('wide')// wide:广角 || zoom:变焦  || ir:红外  
  const [zoomValue, setZoomValue] = useState(5)//变焦数值 （2-10）
  const [pitchAngle, setPitchAngle] = useState(list.pitchAngle === 0 ? 'lookingUp' : 'topView')//俯仰角  //topView:俯视 || lookingUp :仰视
  const downMouse = useRef(false)//是否按下鼠标
  const [downMouseState, setDownMouseState] = useState(false)
  const [videoWidth, setVideoWidth] = useState(280)//直播位置的  宽
  const [videoHeight, setVideoHeight] = useState(210)//直播位置的  高
  const mouseWidth = useRef(0)



  const [camera, setCamera] = useState(false)//开始摄像
  const [cameraDate, setCameraDate] = useState(null)//摄影时长

  const liveAddress = async (type) => {  //获取直播地址
    let obj = {
      access_token: token,
      camera: type,
      dock_id: dock_id,//当前机场id
    }
    let res = await getAirLiveAddress(obj);
    if (res?.data?.url?.default) {
      liveUrlRef.current = res.data?.url?.default || ''
      setVideoId(res.data.video_id)

      liveInterval.current = setInterval(() => {
        updataLive()
      }, 20000);
    }
  }

  const pushFlow = async () => {// 直播推流
    let obj = {
      access_token: token,
      camera: 'cam',
      videoQuality: 0,
      dock_id: dock_id,//当前机场id
    }
    let res = await pushFlowLiveAPI(obj)
    if (res.ret !== 200) { message.warning(res.msg || '推流失败'); return }
    setTimeout(() => {
      liveAddress('cam')
    }, 2000);

  }

  const updataLive = async () => {//更新直播
    let res = await flowLiveUpdateAPI({
      access_token: token,
      video_id: videoId
    })
    if (res.ret !== 200) { message.warning(res.msg || '更新失败'); return }
  }

  const MouseMove = (event) => {  // 监听鼠标移动
    let wid = videoWidth + (event.clientX - mouseWidth.current) * 1.01
    let hei = (wid * 3) / 4
    let pmH = window.innerHeight - 344
    if (hei > pmH) {
      hei = pmH
      wid = (hei * 4) / 3
    }
    if (hei < 225) {
      hei = 225
      wid = (hei * 4) / 3
    }

    setVideoWidth(wid)
    setVideoHeight(hei)
  }

  useEffect(() => {  // 监听 鼠标移动
    if (downMouse.current) {
      window.addEventListener('mousemove', MouseMove)
    }
    return () => {
      window.removeEventListener('mousemove', MouseMove)
    }
    // eslint-disable-next-line
  }, [downMouseState])


  useEffect(() => {
    liveAddress('cam')
    return () => {
      if (liveInterval.current) {
        clearInterval(liveInterval.current)
        liveInterval.current = null
      }
    }
    // eslint-disable-next-line
  }, [])

  return (
    <div className='flex_col jcc align_center pos_rel'>
      <>
        <>{/* 头部操作 */}
          <Card className='marB8' style={{ border: 0 }} styles={{ body: { padding: 0 } }}>
            <div className='flex jcsb align_center h32 pos_rel'
              style={{ width: videoWidth, }}
            >
              <>{/* 拍照动作 */}
                <div className='flex jcc align_center marL8'>
                  {/* 摄像 */}
                  <img
                    className='pointer w14 h14'
                    src={camera ? is_f_Camera : is_t_Camera}
                    alt='是否开始摄像'
                    onClick={async () => {
                      let cam = camera
                      if (cam) {//结束录像
                        let obj = {
                          access_token: token,
                          dock_id: dock_id,
                        }
                        let res = await endVideoAPI(obj)
                        if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }
                        message.success(res.msg || '结束录像')
                        cam = false
                        setCameraDate(null)
                      } else {//开始录像
                        let obj = {
                          access_token: token,
                          dock_id: dock_id,
                        }
                        let res = await startVideoAPI(obj)
                        if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }
                        message.success(res.msg || '开始录像')
                        cam = true
                      }
                      setCamera(cam)
                    }}
                  />

                  {/* 分割线 */}
                  <Divider type="vertical" />

                  {/* 拍照 */}
                  <CameraOutlined
                    className='pointer'
                    onClick={async () => {
                      let obj = {
                        access_token: token,
                        dock_id: dock_id,
                      }
                      let res = await takePhotoAPI(obj)
                      if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }
                      message.success(res.msg || '拍照成功')
                    }}
                  />

                  {/* 分割线 */}
                  <Divider type="vertical" />

                  {/* 刷新 */}
                  <SyncOutlined
                    className='pointer'
                    onClick={async () => {
                      liveUrlRef.current = ''
                      liveAddress('cam')
                    }}
                  />
                </div>
              </>

              <>{/* 镜头 */}
                <>{/* 镜头类型 */}
                  <Segmented
                    value={lensType}
                    options={[
                      { value: 'wide', label: <><ExpandOutlined className='marR6' />广角</>, idx: 1, },
                      { value: 'zoom', label: <><FullscreenExitOutlined className='marR6' />变焦</>, idx: 2, },
                      // { value: 'ir', label: '红外', idx: 3, },
                    ]}
                    onChange={async (value) => {
                      let obj = {
                        access_token: token,
                        dock_id: dock_id,
                        type: value
                      }
                      let res = await changeLensAPI(obj)
                      if (res.ret !== 200) { message.warning(res.msg || '切换镜头失败'); return }
                      message.success(res.msg)
                      setLensType(value)
                    }}
                  />
                </>

                <>{/* 变焦加减 */}
                  <div
                    className='hei100 marB8 flex jcr pos_abs'
                    style={{ top: -40, right: 0, display: lensType === 'zoom' ? `` : `none` }}
                  >
                    <div
                      className='flex align_center radius8'
                      style={{ backgroundColor: '#000' }}
                    >
                      <>{/* + */}
                        <Button
                          icon={<PlusOutlined />}
                          disabled={zoomValue > 9}
                          type='text'
                          onClick={async () => {
                            if (zoomValue >= 1 && zoomValue < 10) {
                              let obj = {
                                access_token: token,
                                dock_id: dock_id,
                                type: lensType,
                                zoom: Number(zoomValue) + 1,
                              }
                              let res = await modifyZoomValueAPI(obj)
                              if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }
                              message.success(res.msg || '增加变焦倍率成功')
                              setZoomValue(Number(zoomValue) + 1)
                            }
                          }}
                        />
                      </>

                      <Divider type="vertical" style={{ padding: 0, margin: 0 }} />

                      <>{/* - */}
                        <Button
                          disabled={zoomValue < 2}
                          icon={<MinusOutlined />}
                          type='text'
                          onClick={async () => {
                            if (zoomValue > 2) {
                              let obj = {
                                access_token: token,
                                dock_id: dock_id,
                                type: lensType,
                                zoom: Number(zoomValue) - 1,
                              }
                              let res = await modifyZoomValueAPI(obj)
                              if (res.ret !== 200) { message.warning(res.msg || '数据跑丢了'); return }
                              message.success(res.msg || '减小变焦倍率成功')
                              setZoomValue(Number(zoomValue) - 1)
                            }
                          }}
                        />
                      </>

                    </div>
                  </div>
                </>
              </>
            </div>
          </Card>
        </>

        <>{/* 视频主体 */}
          <div
            className='pos_rel  radius8 hidden'
            style={{ width: videoWidth, height: videoHeight }}
          >
            {
              liveUrlRef.current
                ? (
                  <FlvVideo
                    type={'cam'}
                    liveUrl={liveUrlRef.current || ''}
                  />
                )
                : (
                  <>{/* 直播错误 */}
                    <div
                      className='flex_col jcc align_center hei100'
                      style={{ backgroundColor: '#0E0E0E' }}
                    >
                      <img className='w38 h38' src={airportWarning} alt='cam直播' />
                      <div className='marTB10 fs14 fw400 lh22 opa45'>
                        DJI Mavic 3E 直播暂未开启
                      </div>
                      <Button
                        type='primary'
                        onClick={() => { pushFlow() }}
                      >
                        开启并观看
                      </Button>
                    </div>
                  </>
                )
            }


            <>{/* 放大缩小 视频框 */}
              <div
                className='pos_abs w40'
                style={{ top: 0, right: 0, cursor: 'ne-resize', height: `${videoHeight}px` }}
                onMouseDown={(event) => {
                  downMouse.current = true
                  setDownMouseState(true)
                  mouseWidth.current = event.clientX
                }}
                onMouseUp={(event) => {
                  setDownMouseState(false)
                  downMouse.current = false
                }}
                onMouseLeave={() => {
                  setDownMouseState(false)
                  downMouse.current = false
                }}
              />

            </>
          </div>
        </>

        <>{/* 俯仰角 */}
          <div
            className='angle pos_abs'
            style={{ bottom: (videoHeight - 210) * 0.2, right: -40, }}
          >
            <Segmented
              id='pitchAngleSegmented'
              value={list.pitchAngle === 0 ? 'lookingUp' : 'topView'}
              vertical={true}
              options={[
                {
                  label: '仰',
                  value: 'lookingUp',
                },
                {
                  label: '俯',
                  value: 'topView',
                },
              ]}
              onChange={async (value) => {
                let obj = {
                  access_token: token,
                  dock_id: dock_id,
                  reset_mode: list.pitchAngle === 0 ? '1' : '0'
                }
                let res = await panTiltControlAPI(obj)
                if (res.ret !== 200) { message.warning(res.msg || '切换俯仰角失败'); return }
                // message.success(res.msg || `切换到${list.pitchAngle === 0 ? `仰视` : `俯视`}成功`)
              }
              }
            />
          </div>
        </>
      </>
    </div>
  )
}
export default LiveVideo;